import gql from 'graphql-tag';
import { DISCOUNT_CODE_FRAGMENT } from '../../queries/Admin/DiscountCodes';

export const CREATE_DISCOUNT_CODE = gql`
  mutation CreateDiscountCode($input: CreateDiscountCodeInput!) {
    createDiscountCode(input: $input) {
      success
      error
      discountCode {
        ...DiscountCodeFragment
      }
    }
  }
  ${DISCOUNT_CODE_FRAGMENT}
`;

export const TOGGLE_DISCOUNT_CODE = gql`
  mutation ToggleDiscountCode($input: ToggleDiscountCodeInput!) {
    toggleDiscountCode(input: $input) {
      success
      error
      discountCode {
        ...DiscountCodeFragment
      }
    }
  }
  ${DISCOUNT_CODE_FRAGMENT}
`;
